
import Vue from 'vue'

export default Vue.extend({
  name: 'ChevronDownSvg',
  props: {
    color: {
      required: false,
      default: 'currentColor',
      type: String,
    },
  },
})
